import React from "react";
import { Button } from "../components/ui/button";
import { Phone, Mouse } from "lucide-react";

const Hero = () => {
  const heroImg =
    "https://images.unsplash.com/photo-1653315917834-04a6d84e132e?crop=entropy&cs=srgb&fm=jpg&q=85";

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex items-center overflow-hidden bg-brand-dark"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      />
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/50 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40" />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 w-full pt-32 pb-24">
        <div className="max-w-3xl">
          <div className="text-brand-yellow text-xs md:text-sm font-bold tracking-[0.25em] mb-6 animate-fade-in-up">
            DERBYSHIRE &nbsp;·&nbsp; NOTTINGHAMSHIRE &nbsp;·&nbsp; LEICESTERSHIRE
          </div>

          <h1 className="font-display text-white leading-[0.95] mb-8 animate-fade-in-up">
            <span className="block text-6xl md:text-7xl lg:text-8xl">DIG IT.</span>
            <span className="block text-6xl md:text-7xl lg:text-8xl">BUILD IT.</span>
            <span className="block text-6xl md:text-7xl lg:text-8xl text-brand-yellow">
              FINISH IT RIGHT.
            </span>
          </h1>

          <p className="text-white/90 text-base md:text-lg max-w-xl mb-10 leading-relaxed animate-fade-in-up">
            Professional groundworks and landscaping services across Derbyshire,
            Nottinghamshire, Leicestershire and surrounding areas.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up">
            <a href="tel:07784732546">
              <Button className="bg-brand-yellow hover:bg-brand-yellow-dark text-brand-dark font-bold tracking-wider text-sm px-8 py-7 rounded-md shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all">
                <Phone size={16} className="mr-2" />
                CALL KYLE: 07784 732546
              </Button>
            </a>
            <Button
              onClick={() => scrollTo("contact")}
              variant="outline"
              className="border-2 border-white/40 bg-transparent hover:bg-white hover:text-brand-dark text-white font-bold tracking-wider text-sm px-8 py-7 rounded-md transition-all"
            >
              GET A FREE QUOTE
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/60">
        <Mouse size={22} className="animate-bounce-slow" />
      </div>
    </section>
  );
};

export default Hero;
